<template>
  <el-container class="screen-container">
    <!-- 顶部导航栏 -->
    <el-header class="header">
      <h1 class="title">安全环保实时监管一体化平台</h1>
      <div class="header-left">
        <div
          class="nav-item"
          :class="{ active: $route.path === '/home' }"
          @click="$router.push('/home')"
        >
          <span class="nav-text">首页</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: $route.path === '/products' }"
          @click="$router.push('/products')"
        >
          <span class="nav-text">安全管控</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: $route.path === '/contact' }"
          @click="$router.push('/contact')"
        >
          <span class="nav-text">告警记录</span>
        </div>
        <div
          class="nav-item"
          :class="{ active: $route.path === '/baseset' }"
          @click="$router.push('/baseset')"
        >
          <span class="nav-text">基础配置</span>
        </div>
      </div>

      <div class="header-right">
        <el-icon><Cpu /></el-icon>
        <el-icon><Download /></el-icon>
        <el-icon><Search /></el-icon>

        <el-dropdown
          effect="dark"
          placement="bottom"
          trigger="click"
          @command="handleDropdownCommand"
        >
          <span class="admin">admin</span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">退出系统</el-dropdown-item>
              <el-dropdown-item command="about">关于</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>

    <el-main class="main-content">
      <router-view />
    </el-main>
  </el-container>
</template>

<script setup>
import { ref, reactive } from "vue";
import { Cpu, Download, Search } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
const router = useRouter();
// 处理下拉菜单命令
const handleDropdownCommand = (command) => {
  router.push("/login");
};
// 模拟数据
</script>

<style lang="scss" scoped>
.screen-container {
  width: 100vw;
  height: 100vh;
  background: #0a1020;
  color: #d9e6f7;
  font-family: "Microsoft YaHei", sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.header {
  height: 60px;
  background: linear-gradient(90deg, #050b1a 0%, #0f1a30 50%, #050b1a 100%);
  border-bottom: 1px solid #1a3a6a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;

  //   &::before,
  //   &::after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     width: 20px;
  //     height: 100%;
  //     background: linear-gradient(
  //       180deg,
  //       transparent 0%,
  //       #00ccff 50%,
  //       transparent 100%
  //     );
  //   }
  &::before {
    left: 0;
  }
  &::after {
    right: 0;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
    .nav-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 24px;
      border-radius: 4px;
      cursor: pointer;
      color: #8aa2c2;
      font-size: 14px;
      transition: all 0.3s ease;
      position: relative;

      // 悬浮效果
      &:hover {
        color: #00ccff;
        background-color: rgba(0, 204, 255, 0.05);
      }

      // 激活状态
      &.active {
        background: linear-gradient(135deg, #0066cc 0%, #0099ff 100%);
        color: #ffffff;
        box-shadow: 0 0 10px rgba(0, 153, 255, 0.3);

        // 激活态发光效果
        &::after {
          content: "";
          position: absolute;
          top: -1px;
          left: -1px;
          right: -1px;
          bottom: -1px;
          border-radius: 4px;
          background: linear-gradient(135deg, #00ccff 0%, transparent 50%);
          opacity: 0.5;
          pointer-events: none;
        }
      }

      // 导航图标
      .nav-icon {
        font-size: 16px;
      }

      // 导航文字
      .nav-text {
        font-weight: 500;
      }
    }
    .company-select {
      width: 150px;
      :deep(.el-input__wrapper) {
        background: #0f1a30;
        border: 1px solid #1a3a6a;
        box-shadow: none;
      }
      :deep(.el-input__inner) {
        color: #d9e6f7;
      }
    }

    .logo {
      font-size: 20px;
      font-weight: bold;
      color: #00ccff;
    }
  }

  .title {
    font-size: 24px;
    color: #d9e6f7;
    text-shadow: 0 0 10px #00ccff;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 18px;
    color: #00ccff;

    .admin {
      font-size: 14px;
      color: #d9e6f7;
    }
  }
}

.main-content {
  height: 100%;
  // flex: 1;
  display: flex;
  padding: 10px;
  gap: 10px;
  overflow: hidden;
}
.el-dropdown-menu {
  background-color: transparent !important;
}
:deep(.el-dropdown-menu__item) {
  color: #fff !important;
}
</style>
